/**
 * Directive: scheduleRange
 */
angular.module('acme.common.directive.scheduleRange', [
  'acme.common.directive.scheduleRangeCreate',
  'acme.common.directive.scheduleRangeView',
  'acme.common.directive.scheduleRangeEdit'
])
.directive('scheduleRange', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/scheduleRange/scheduleRange.tpl.html',
      scope: {
        model: '=',
        state: '@',
        index: '@',
        label: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $scope.$watch('model', $scope.scheduleRange.onModelUpdate);
      },

      controller: ['$scope', function($scope) {

        $scope.scheduleRange = {

          model: {},

          state: '',

          init: function() {
            $scope.$on('scheduleRange::stateChange', this.onStateChange);
            this.state = $scope.state;
          },

          isInState: function(name) {
            return (this.state === name);
          },

          getState: function(state) {
            return this.state;
          },

          onStateChange: function(data) {
            this.state = data.state;
          },

          onModelUpdate: function(model) {
            $scope.scheduleRange.model = model;
          }

        };

        $scope.scheduleRange.init();

      }]

    };

}]);